import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h2>THis page cant found herre 404!!</h2>
        </div>
    );
};

export default Notfound;